import React from "react";
import "./index.scss";
export const Introduction = () => {
  return (
    <div className="introduction mt-4">
      <div className="introduction-container d-flex align-items-end">
        <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center mb-2 mb-md-5">
          <div className="col-12 col-md-4 mx-auto ">
            <p className="introduction-title">
              <strong> Introduction</strong>
              <br />
              BENTO HABITAT
            </p>
          </div>
          <div className="col-12 col-md-8 mx-auto ">
            <p className="introduction-text">
              <strong>Chez Bento Habitat</strong> , IDF, nous mettons notre
              expertise au service de la performance énergétique et du
              patrimoine immobilier. Depuis plus de X ans, nous accompagnons les
              particuliers, copropriétés et investisseurs dans leurs projets de
              rénovation en Île-de-France.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
